import styled from "styled-components";

export const AppContainer = styled.div`
  //   background: url(/home.svg) no-repeat center center;
  background-color: #ffffff;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  min-height: 100vh;
  width: auto;
  // padding-top: 4.55rem;
  @media (max-width: 768px) {
    min-height: auto;
    flex-direction: column;
  }
`;
export const HeaderContainer = styled.div`
  display: flex;
  overflow: hidden;
  background: #ffffff;
  z-index: 100;
  position: fixed;
  width: 100%;
  z-index: 1000;
  top: 0;
  flex-direction: row;
  justify-content: space-between;
  box-shadow: 0px 0px 19px #00000085;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
export const Heading = styled.h1`
  color: #000;
  cursor: pointer;
  font-size: 24px;
  line-height: 22px;
  text-decoration: none !important;
  font-family: Poppins;
  @media (max-width: 768px) {
    font-size: 20px;
  }
  span {
    color: #7f8c8d;
    font-size: 12px;
    font-weight: 500;
    @media (max-width: 768px) {
      font-size: 10px;
    }
  }
`;
export const Nav = styled(Heading)`
  font-size: 1rem;
  background: #3772ff;
  color: #fff;
  float: right;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 1.4rem;
  @media (max-width: 768px) {
    font-size: 15px;
    margin-left: 2rem;
  }
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 2rem 0rem;
  margin-top: 4rem;
  justify-content: center;
  span {
    color: #423d3d;
    font-size: 1rem;
    font-weight: 500;
    font-family: Poppins;
  }
`;

export const CreatorContainer = styled.div`
  background: #3173d7;
  border-radius: 2rem;
  margin-top: 10rem;
  padding: 0rem 2rem;
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-weight: 500 !important;
  @media (max-width: 768px) {
    font-size: 15px;
  }
  a {
    color: #fff;
    text-decoration: underline;
  }
`;

export const Header = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 90%;
  }
`;
